// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
 //apiEndPoint: 'http://localhost:61184' // Local
  //apiEndPoint: 'http://team.creatingwow.in:444/' //QA
  //apiEndPoint: 'http://team.creatingwow.in:450/' //Stage
  //apiEndPoint: 'https://team.creatingwow.in:/' //Prod
  //apiEndPoint:  'https://team.creatingwow.in/'
   apiEndPoint: '' //Prod

};



// WEBPACK FOOTER //
// ./src/environments/environment.ts